import { Components, Theme } from '@mui/material';

// todo: add typography styles once Typography theme is merged from PR #172
const TextFieldTheme: Components['MuiTextField'] = {
  styleOverrides: {
    root: (props) => {
      const theme = props.theme as Theme;

      return {
        '.MuiOutlinedInput-root': {
          borderRadius: theme.cornerRadius.xs,
          height: '48px',
          fieldset: {
            borderColor: theme.palette.neutral.border
          },
          '&.Mui-focused fieldset': {
            borderColor: theme.palette.neutral.primary
          },
          '&.MuiInputBase-multiline': {
            height: 'unset'
          }
        },
        '.MuiOutlinedInput-input': {
          padding: `${theme.space.xs} ${theme.space.sm}`,
          fontSize: theme.typography.paragraphSm.fontSize,
          lineHeight: theme.typography.paragraphSm.lineHeight,
          fontWeight: theme.typography.paragraphSm.fontWeight,
          '::placeholder': {
            color: theme.palette.neutral.secondary
          }
        },

        '.MuiInputLabel-root': {
          transform: `translate(${theme.space.sm}, 12px) scale(1)`,
          color: theme.palette.neutral.secondary,
          fontSize: theme.typography.paragraphSm.fontSize,
          lineHeight: theme.typography.paragraphSm.lineHeight,
          fontWeight: theme.typography.paragraphSm.fontWeight,
          '&.Mui-focused, &.MuiFormLabel-filled': {
            transform: 'translate(14px, -8px)',
            color: theme.palette.neutral.primary,
            fontSize: theme.typography.mini.fontSize,
            lineHeight: theme.typography.mini.lineHeight,
            fontWeight: theme.typography.mini.fontWeight
          }
        },
        '.MuiOutlinedInput-notchedOutline > legend': {
          fontSize: theme.typography.mini.fontSize
        }
      };
    }
  }
};

export default TextFieldTheme;
